import { useCallback } from 'react';
import { useGameStore } from '../hooks/useGameStore';

export function PlayAgainButton() {
  const reset = useGameStore(useCallback((state) => state.reset, []));

  function handlePlayAgain() {
    reset();
  }

  return (
    <button
      onClick={handlePlayAgain}
      className="fixed right-14 top-14 w-40 h-40 p-8 rounded-full bg-primary transform transition-transform rotate-12 hover:bg-primary-dark focus:outline-none text-white text-3xl text-center"
    >
      Spela igen!
    </button>
  );
}
